






































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { UserProfile } from "@api/models/UserProfile";
import UsersListItem from "@share/common/users-list/UsersListItem.vue";
import BackButton from "../../../../service/components/common/back-button/BackButton.vue";
import ChatProfileInfo from "./ChatProfileInfo.vue";
import { Tag } from "@api/models/Tag";
import { TagsState } from "@service/store/types/TagsState";

@Component({
    name: 'ChatProfile',
    components: { UsersListItem, BackButton, ChatProfileInfo }
})
export default class ChatProfile extends Vue {
    @Prop({ required: true }) user: UserProfile;
    @Prop({ default: false }) forceRollUp: boolean;

    rolledUp = false;

    created() {
        this.checkIsRolledUp();

        if(!this.tagsState.usersTags) {
            this.$store.dispatch("tags/loadUsersTags");
        }
    }

    checkIsRolledUp() {
        const rolledUp = JSON.parse(localStorage.getItem(this.lsKey) || 'false');

        if(rolledUp) {
            this.rolledUp = true;
        }
        else {
            this.setIsRolledUp(false);
        }
    }

    rollUpClick(event?: MouseEvent) {
        event?.stopPropagation();

        const prevent = "exist"

        this.rolledUp = !this.rolledUp;

        if(this.rolledUp) {
            this.setIsRolledUp(true);
        }
        else {
            this.setIsRolledUp(false);
            this.$emit('expand')
        }
    }

    setIsRolledUp(rolledUp: boolean) {
        if(rolledUp) {
            localStorage.setItem(this.lsKey, JSON.stringify(true));
        }
        else {
            localStorage.removeItem(this.lsKey);
        }
    }

    @Watch('forceRollUp')
    watchForceRollUp(value: boolean) {
        if(value) {
            this.rollUpClick();
        }
    }

    cancel(event: MouseEvent) {
        event.stopPropagation();
        this.$emit('cancel');
    }

    profileContentClick(event: MouseEvent) {
        event.stopPropagation();
    }

    makeTag(tag: Tag) {
        return { tag }
    }

    get infoExist() {
        return Boolean(this.user?.biography || this.lookingForTags.length || this.offerTags.length);
    }

    get lsKey() {
        return `${process.env.VUE_APP_SERVER}_rolled-up-profile_${this.user.userId}_${this.$store.state.session.backend}`;
    }

    get tagsState(): TagsState {
        return this.$store.state.tags;
    }

    get tags(): Tag[] {
        return this.tagsState.usersTags || []
    }

    get lookingForTags() {
        return this.tags
            .filter((tag) => this.user?.interestingTagIds?.includes(tag.id))
            .map(this.makeTag);
    }

    get offerTags() {
        return this.tags
            .filter((tag) => this.user?.tagsIds?.includes(tag.id))
            .map(this.makeTag);
    }
}
